import { useMemo } from "react";
import { CircularProgress } from "@mui/material";

import { ConnectedAccounts } from "../../../Pages/Connected Accounts";

import useConnectBankAccount from "../../../CustomHooks/useConnectBankAccount";
import { useConnectedAccounts } from "../../../CustomHooks/Queries";
import { useModalContext } from "../../../Contexts/ModalContext";

import { modalVariants } from "../../../Utils/constants";

export default function renderSelectConnectedAccounts(modalContext, props) {
  const { updateModalComponent, setModalTitle, setModalClassName, setModalVariant, pushModalStack } = modalContext;

  pushModalStack(() => renderSelectConnectedAccounts(modalContext, props));
  updateModalComponent(() => <ConnectedAccountsModal {...props} />);
  setModalTitle("Connected Accounts");
  setModalClassName("rendering-page-content connected-accounts-modal");
  setModalVariant(modalVariants.formDialog);
}

function ConnectedAccountsModal(props) {
  const { setModalClassName, onModalClose } = useModalContext();
  const { data: connectedAccounts } = useConnectedAccounts();

  const isConnected = useMemo(
    () => (connectedAccounts?.data?.data?.accounts?.length ?? 0) > 0,
    [connectedAccounts],
  );

  const { isSavingAccount, plaidReady, openPlaid } = useConnectBankAccount({
    onSuccess: () => onModalClose(),
    onError: onModalClose,
    onInitiatingSave: () => setModalClassName(null),
    onExit: () => setModalClassName("rendering-page-content connected-accounts-modal"),
  });

  const handleAddBank = () => {
    if (!isSavingAccount && plaidReady) {
      setModalClassName("d-none");
      openPlaid();
    }
  };

  if (isConnected) {
    return <ConnectedAccounts presentedForSelection {...props} />;
  }

  return (
    <div className="connect-bank-empty-state">
      <div className="cb-es-hero">
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
          <path d="M20 4L4 12V16H36V12L20 4Z" stroke="var(--accent)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M8 16V28" stroke="var(--accent)" strokeWidth="2" strokeLinecap="round" />
          <path d="M16 16V28" stroke="var(--accent)" strokeWidth="2" strokeLinecap="round" />
          <path d="M24 16V28" stroke="var(--accent)" strokeWidth="2" strokeLinecap="round" />
          <path d="M32 16V28" stroke="var(--accent)" strokeWidth="2" strokeLinecap="round" />
          <path d="M4 28H36V32H4V28Z" stroke="var(--accent)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M2 32H38V36H2V32Z" stroke="var(--accent)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        <h3 className="cb-es-title">Connect your bank</h3>
        <p className="cb-es-subtitle">Always have funds ready to spend and earn cash back.</p>
      </div>
      <button className="primary-button cb-es-cta" onClick={handleAddBank} disabled={isSavingAccount || !plaidReady}>
      Set up in 1 minute {(isSavingAccount || !plaidReady) && <CircularProgress /> }
      </button>
      <div className="cb-es-trust">
        <span className="cb-es-dot">&middot;</span>
        <svg width="14" height="14" viewBox="0 0 18 18" fill="none">
          <rect x="3" y="8" width="12" height="8" rx="1.5" stroke="var(--accent)" strokeWidth="1.2" />
          <path d="M6 8V5.5C6 3.84 7.34 2.5 9 2.5C10.66 2.5 12 3.84 12 5.5V8" stroke="var(--accent)" strokeWidth="1.2" strokeLinecap="round" />
        </svg>
        <span>256-bit encryption</span>
        <span className="cb-es-dot">&middot;</span>
        <svg width="14" height="14" viewBox="0 0 18 18" fill="none">
          <path d="M9 1.5L3 4.5V8.25C3 12.35 5.56 16.17 9 17.25C12.44 16.17 15 12.35 15 8.25V4.5L9 1.5Z" stroke="var(--accent)" strokeWidth="1.2" strokeLinejoin="round" />
          <path d="M6.5 9L8 10.5L11.5 7" stroke="var(--accent)" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        <span>Powered by Plaid</span>
      </div>
    </div>
  );
}
